import { render } from "./RegisterIndex.vue?vue&type=template&id=75111524&scoped=true"
import script from "./RegisterIndex.vue?vue&type=script&lang=js"
export * from "./RegisterIndex.vue?vue&type=script&lang=js"

import "./RegisterIndex.vue?vue&type=style&index=0&id=75111524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75111524"]])

export default __exports__